<template>
  <b-alert :show="!isCookie" v-if="!isCookie" id="cookie-alert">
    <div id="cookie-alert-text">
      {{alertText}}
    </div>
    <div id="cookie-alert-button">
      <b-button @click="checkCookieInfo" class="mr-2" variant="outline-primary">Подробнее</b-button>
      <b-button @click="acceptCookie" variant="outline-primary">Ок</b-button>
    </div>
  </b-alert>
</template>

<script>
export default {
  name: 'CookieAlert',
  data() {
    return {
      alertText: 'Наш сайт использует cookie-файлы. Продолжая использовать сайт, вы соглашаетесь с использованием '
        + 'данных технологий.',
      isCookie: false
    }
  },
  beforeMount() {
    if (this.$cookies.get('isKnowAboutCookie') === 'true') {
      this.isCookie = true
    }
  },
  methods: {
    acceptCookie() {
      this.$cookies.set('isKnowAboutCookie', true, '10y')
      this.isCookie = true
    },
    checkCookieInfo() {
      this.$router.push('/cookies')
    }
  }
}
</script>

<style scoped>
  #cookie-alert {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin: 0;
    z-index: 5000;
  }
  #cookie-alert-text {
    display: inline-block;
    float: left;
    line-height: 2;
  }
  #cookie-alert-button {
    display: inline-block;
    float: right
  }
</style>
